export const smallNumber = (number) => {
  number = Number(number);

  if (isNaN(number)) {
    // throw new Error('Not a Number!');
    // console.error('Not a Number');
    return;
  }

  return number < 1000 ? number : number < 1000000 ? (number / 1000).toFixed(0) + 'k' : number < 1000000000 ? (number / 1000000).toFixed(1) + 'm' : number < 1000000000000 ? (number / 1000000000).toFixed(1) + 'b' : 'Err'
};



// WEBPACK FOOTER //
// ./src/helpers/number.js